export default __webpack_public_path__ + "static/media/uploader-roche-problem-1.4b08be44.png";